import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BaseModal from 'components/BaseModal'
import { Button } from '@driftt/tide-core'
import { deleteApplication } from 'api/developerApi'
import './style.css'

class DeleteAppModal extends Component {

  static propTypes = {
    onCloseInitiated: PropTypes.func.isRequired,
    onAppDeleted: PropTypes.func.isRequired,
    appId: PropTypes.string.isRequired,
    appName: PropTypes.string.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isDeleting: false
  }

  deleteApp = () => {
    const { appId, onAppDeleted, showErrorNotification } = this.props

    const onDone = () => {
      this.setState({ isDeleting: false })
      onAppDeleted()
    }
    const onError = () => {
      this.setState({ isDeleting: false })
      showErrorNotification('Ooops, we couldn’t delete your app. Please try again.')
    }

    const onStateSet = () => deleteApplication(appId)
      .then(onDone)
      .catch(onError)

    this.setState({ isDeleting: true }, onStateSet)
  }

  render() {
    const { onCloseInitiated, appName } = this.props
    const { isDeleting } = this.state

    return (
      <BaseModal onCloseInitiated={onCloseInitiated}>
        <div className="delete-app-modal">
          <span className="delete-app-modal-title">
            {`Delete ${appName} App`}
          </span>
          <p className="delete-app-modal-description">
            You’re about to delete your app forever. Make sure to communicate with your users so they can prepare for any changes that need to be made.
          </p>
          <div className="delete-app-modal-buttons">
            <Button
              type="secondary"
              onClick={onCloseInitiated}
              className="delete-app-modal-button-cancel">
              Cancel
            </Button>
            <Button
              className="delete-app-modal-button-delete"
              onClick={this.deleteApp}
              loading={isDeleting}>
              Delete App
            </Button>
          </div>
        </div>
      </BaseModal>
    )
  }
}

export default DeleteAppModal
